<template>
  <div>
    <mt-cell title="申诉处理" to="/apply/untie" is-link>
      <i slot="icon" class="iconfont icon-completed"></i>
    </mt-cell>
    <mt-cell title="学生退班" to="/student/del" is-link>
      <i slot="icon" class="iconfont icon-idcard"></i>
    </mt-cell>
    <mt-cell title="苹果审核" to="/apple/audit" is-link>
      <i slot="icon" class="iconfont icon-exchange"></i>
    </mt-cell>
    <mt-cell title="意见反馈" to="/feedback" is-link>
      <i slot="icon" class="iconfont icon-question"></i>
    </mt-cell>
    <mt-cell title="数据统计" to="/report/register" is-link>
      <i slot="icon" class="iconfont icon-photo"></i>
    </mt-cell>
  </div>
</template>

<script>
export default {
  name: 'Main'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Main.vue